import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CommonImage from '@/components/CommonImage';
import { HEADER_STYLE } from '@/features/task-configuration/constants';

const DashboardCard = ({
	isShowCount = false,
	card,
	onEdit,
	onDelete,
	isReadOnly = false,
	shouldDisableFilter = false,
	onClickFilterItem = () => {}
}) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const navigate = useNavigate();
	const scrollRef = useRef(null);
	let headerStyle = HEADER_STYLE[0]; // Default style
	if (card?.titleStyle) {
		try {
			const parsedStyle = JSON.parse(card?.titleStyle);

			if (parsedStyle && parsedStyle?.bgColor && parsedStyle?.textColor && parsedStyle?.icon) {
				headerStyle = parsedStyle;
			} else {
				headerStyle = HEADER_STYLE?.find((style) => style?.id === parsedStyle?.id) || HEADER_STYLE[0];
			}
		} catch {
			headerStyle = HEADER_STYLE?.find((style) => style?.id === card?.titleStyle) || HEADER_STYLE[0];
		}
	}

	// Get filter list for display
	const filters = card?.filters || [];
	const visibleFilters = isExpanded ? filters : filters.slice(0, 5);
	const remainingCount = filters.length - 5;

	const handleFilterClick = (filter) => {
		if (shouldDisableFilter && !(filter?.styleCount > 0)) return;
		// Call the original callback
		onClickFilterItem?.(filter);
		// Navigate with query params for shareable URL
		const filterTitle = filter?.title ? encodeURIComponent(filter.title) : '';
		if (isReadOnly) {
			navigate(
				`/my-dashboard?tab=MY_DASHBOARD_STYLES&filterId=${filter.id}${
					filterTitle ? `&filterTitle=${encodeURIComponent(filterTitle)}` : ''
				}`
			);
		} else {
			window.open(
				`/my-dashboard?tab=MY_DASHBOARD_STYLES&filterId=${filter.id}${
					filterTitle ? `&filterTitle=${encodeURIComponent(filterTitle)}` : ''
				}`,
				'_blank'
			);
		}
	};

	const handleViewMore = () => {
		setIsExpanded(!isExpanded);
	};

	useEffect(() => {
		if (isExpanded && scrollRef.current) {
			scrollRef.current.scrollTo({
				top: scrollRef.current.scrollHeight,
				behavior: 'smooth'
			});
		}
	}, [isExpanded]);

	return (
		<div className="task-category-card shadow-2dp">
			<div
				className="task-category-header d-flex align-items-center justify-content-between mb-3 p-1"
				style={{ backgroundColor: headerStyle.bgColor }}
			>
				<div className="d-flex align-items-center">
					<CommonImage src={headerStyle.icon} className="mr-2" />
					<p className="regular-14 weight-600" style={{ color: headerStyle.textColor }}>
						{card?.title || 'Untitled Card'}
					</p>
				</div>
				{!isReadOnly && (
					<div className="option">
						<div className="dropdown">
							<button
								className="btn btn-default dropdown-toggle"
								type="button"
								id={`menu-${card?.id}`}
								data-toggle="dropdown"
							>
								<CommonImage
									src="/icons/more_vertical.svg"
									alt="more_icon"
									width={24}
									height={24}
								/>
							</button>
							<ul className="dropdown-menu dropdown-menu-right shadow-lg">
								<li className="px-4 pb-3 pt-3">
									<span
										className="font-weight-normal text-black cursor-pointer"
										onClick={() => onEdit?.(card)}
									>
										Edit
									</span>
								</li>
								<li className="px-4 pb-3">
									<span
										className="font-weight-normal text-black cursor-pointer"
										onClick={() => onDelete?.(card)}
									>
										Delete
									</span>
								</li>
								<li className="px-4 pb-3">
									<span className="font-weight-normal text-black cursor-pointer">
										SL: {card?.serial}
									</span>
								</li>
							</ul>
						</div>
					</div>
				)}
			</div>
			<div className="task-category-body scroll-y-label" ref={scrollRef}>
				{filters.length > 0 ? (
					<ul className="task-list">
						{visibleFilters.map((filter, index) => (
							<li
								key={filter.id || index}
								className={`regular-14 gray_dark_01 mb-2 ${shouldDisableFilter && !(filter?.styleCount > 0) ? 'cursor-none gray_dark_03' : ''}`}
								onClick={() => handleFilterClick(filter)}
							>
								{filter.title}{' '}
								{isShowCount && (
									<span className="gray_dark_01">({filter?.styleCount || 0})</span>
								)}
							</li>
						))}
					</ul>
				) : (
					<p className="regular-14 gray_dark_01 text-center">No filters added</p>
				)}
			</div>
			{remainingCount > 0 && (
				<div
					className="view-more d-flex align-items-center cursor-pointer mt-2"
					onClick={handleViewMore}
				>
					<p className="gray_dark_01 regular-14 weight-400 pb-1 mr-1">
						{isExpanded ? 'View less' : `View ${remainingCount} more`}
					</p>
					<CommonImage
						className="arrow-icon"
						src="/icons/down-arrow-gray-dark-01.svg"
						width={20}
						height={20}
						style={{
							transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
							transition: 'transform 0.3s ease'
						}}
					/>
				</div>
			)}
		</div>
	);
};

export default DashboardCard;
